module.exports = __webpack_public_path__ + "media/images/kimcrow-d8af6bd05a84f50c9eebe9827cb3218e712782a8b81d0793509fbedc032acf23.jpg";